module.exports = __webpack_public_path__ + "static/media/grand-prize.8d4eb415.svg";